// Mesquite Mafia: Reactive State & Directive Engine
import { playSFX, startBGM, bgmPlaylist, currentBGMIndex } from './audio.js';

export let currentActiveDirective = null;

export let state = {
      cash: 500,
      cleanCapital: 0,
      product: 100,
      scrap: 50,
      cred: 25,
      xp: 0,
      level: 1,
      xpToNext: 250,
      combo: 0,
      compoundLevel: 1,
      compoundXp: 0,
      compoundXpToNext: 200,
      policeHeat: 0,
      roadblocks: { us80: false, i635: false },
      combatStance: 'bruiser',
      convoys: [],
      rivalThreats: {
        mike: { name: "Big Mike", target: 's1_scrap', threat: 15, archetype: 'bruiser' },
        hector: { name: "Hector Alvarez", target: 's2', threat: 30, archetype: 'hitman' },
        beau: { name: "Beau Montgomery", target: 's3', threat: 20, archetype: 'biker' },
        vance: { name: "Director Vance", target: 's4', threat: 50, archetype: 'police' }
      },
      currentPursuit: null,
      territories: {
        s1: { control: 40, owner: 'player', income: {cash: 25, product: 10}, troops: 10, defenseLevel: 1, unlocked: true },
        s1_scrap: { control: 20, owner: 'neutral', income: {scrap: 20}, troops: 10, defenseLevel: 1, unlocked: true },
        s2: { control: 0, owner: 'hector', income: {cash: 400}, troops: 50, defenseLevel: 3, unlocked: false, reqCompound: 2 },
        s3: { control: 0, owner: 'beau', income: {cash: 900}, troops: 80, defenseLevel: 5, unlocked: false, reqCompound: 3 },
        s4: { control: 0, owner: 'vance', income: {cash: 2500}, troops: 150, defenseLevel: 7, unlocked: false, reqCompound: 4 }
      },
      missions: {
        chapter1: {
          name: "Chapter 1: The Room 114 Hustle",
          unlocked: true,
          tasks: {
            c1_cook: { id: "c1_cook", title: "Package Starter Brick", desc: "Run 1 cook operation in Room 114 Operations Center", req: 1, progress: 0, done: false, reward: { cash: 250, product: 50, xp: 50 }, targetTab: 'compound', targetAction: 'cook' },
            c1_wash: { id: "c1_wash", title: "Launder Street Cash", desc: "Run 1 back-office wash operation in motel laundry", req: 1, progress: 0, done: false, reward: { cash: 350, cleanCapital: 100, cred: 15, xp: 60 }, targetTab: 'compound', targetAction: 'wash' },
            c1_salvage: { id: "c1_salvage", title: "Scavenge Big Town Salvage", desc: "Dispatch a gathering march to Big Town Salvage", req: 1, progress: 0, done: false, reward: { scrap: 100, cash: 300, xp: 75 }, targetTab: 'world', targetAction: 'march_s1_scrap' },
            c1_convoy: { id: "c1_convoy", title: "Dispatch US-80 Supply Convoy", desc: "Fund & send a supply convoy along US-80 corridor ($250)", req: 1, progress: 0, done: false, reward: { cash: 500, scrap: 50, cred: 25, xp: 100 }, targetTab: 'world', targetAction: 'convoy' },
            c1_compound: { id: "c1_compound", title: "Upgrade HQ to Level 2", desc: "Upgrade Room 114 to Surveillance Nest ($1,000 Cash, 150 Scrap)", req: 2, progress: 1, done: false, reward: { cash: 1000, cred: 50, xp: 150, unlockSector: 's2' }, targetTab: 'compound', targetAction: 'upgrade_compound' }
          }
        },
        chapter2: {
          name: "Chapter 2: Town East Mall Infiltration",
          unlocked: false,
          tasks: {
            c2_mall_raid: { id: "c2_mall_raid", title: "Hit Town East Corridor", desc: "Complete 2 raids against Sector 2 (Town East)", req: 2, progress: 0, done: false, reward: { cash: 2500, cred: 75, xp: 200 }, targetTab: 'world', targetAction: 'march_s2' },
            c2_hector_duel: { id: "c2_hector_duel", title: "Confront Hector's Cartel", desc: "Win 1 arena battle against Hector Alvarez", req: 1, progress: 0, done: false, reward: { cash: 3500, scrap: 200, cred: 100, xp: 250 }, targetTab: 'arena', targetAction: 'boss_hector' },
            c2_clean_bank: { id: "c2_clean_bank", title: "Launder Street Capital", desc: "Complete 4 wash operations in Room 114", req: 4, progress: 0, done: false, reward: { cash: 4000, cred: 150, xp: 300 }, targetTab: 'compound', targetAction: 'wash' },
            c2_compound_up: { id: "c2_compound_up", title: "Fortify HQ to Level 3", desc: "Upgrade Compound to Reinforced Bunker ($4,000 Cash, 400 Scrap)", req: 3, progress: 1, done: false, reward: { cash: 5000, cred: 200, xp: 400, unlockSector: 's3' }, targetTab: 'compound', targetAction: 'upgrade_compound' }
          }
        },
        chapter3: {
          name: "Chapter 3: Rodeo Turf War",
          unlocked: false,
          tasks: {
            c3_rodeo_shakedown: { id: "c3_rodeo_shakedown", title: "Rodeo Arena Shakedown", desc: "Push Mesquite Rodeo control to 50%", req: 50, progress: 0, done: false, reward: { cash: 7500, scrap: 500, xp: 500 }, targetTab: 'world', targetAction: 'march_s3' },
            c3_beau_defeat: { id: "c3_beau_defeat", title: "Dethrone Beau The Bull", desc: "Defeat Beau Montgomery in Arena combat", req: 1, progress: 0, done: false, reward: { cash: 10000, cred: 500, xp: 750 }, targetTab: 'arena', targetAction: 'boss_beau' },
            c3_convoy_web: { id: "c3_convoy_web", title: "Run Interstate Convoys", desc: "Successfully dispatch 4 supply convoys", req: 4, progress: 0, done: false, reward: { cash: 12000, scrap: 800, cred: 600, xp: 900 }, targetTab: 'world', targetAction: 'convoy' },
            c3_citadel: { id: "c3_citadel", title: "Build Syndicate Citadel", desc: "Upgrade Compound to Level 4 Citadel ($10,000 Cash, 1,000 Scrap)", req: 4, progress: 1, done: false, reward: { cash: 15000, cred: 1000, xp: 1200, unlockSector: 's4' }, targetTab: 'compound', targetAction: 'upgrade_compound' }
          }
        },
        chapter4: {
          name: "Chapter 4: City Hall Coup",
          unlocked: false,
          tasks: {
            c4_pd_heat: { id: "c4_pd_heat", title: "Subvert City Hall Patrols", desc: "Perform 3 tactical scanner intercepts", req: 3, progress: 0, done: false, reward: { cash: 20000, cred: 1500, xp: 1500 }, targetTab: 'compound', targetAction: 'scanner' },
            c4_vance_showdown: { id: "c4_vance_showdown", title: "Overthrow Director Vance", desc: "Defeat Director Bill Vance in final arena battle", req: 1, progress: 0, done: false, reward: { cash: 50000, cred: 5000, xp: 5000 }, targetTab: 'arena', targetAction: 'boss_vance' }
          }
        }
      }
    };

export function escapeHtml(str) {
  if (!str) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export function log(msg) {
      const box = document.getElementById('combat-log');
      if(box) {
        box.innerHTML += `<div>${msg}</div>`;
        box.scrollTop = box.scrollHeight;
      }
    }

export function updateCurrencies() {
      const c = document.getElementById('cash-val');
      const p = document.getElementById('product-val');
      const s = document.getElementById('scrap-val');
      const cr = document.getElementById('cred-val');
      if (c) c.innerText = '$' + (state.cash || 0).toLocaleString();
      if (p) p.innerText = (state.product || 0).toLocaleString();
      if (s) s.innerText = (state.scrap || 0).toLocaleString();
      if (cr) cr.innerText = (state.cred || 0).toLocaleString();

      document.querySelectorAll('.resource-badge').forEach(badge => {
        badge.classList.remove('currency-bump');
        void badge.offsetWidth;
        badge.classList.add('currency-bump');
      });
    }

export function addXP(amount) {
      state.xp += amount;
      let leveledUp = false;
      while(state.xp >= state.xpToNext && state.level < 50) {
        state.xp -= state.xpToNext;
        state.level++;
        state.xpToNext = Math.floor(state.level * 1000 * 1.15);
        leveledUp = true;
      }
      updateXPUI();
      if(leveledUp) {
        playSFX('tab_switch');
        const flash = document.createElement('div');
        flash.className = 'level-up-flash';
        document.body.appendChild(flash);
        setTimeout(() => flash.remove(), 800);
        log(`🌟 LEVEL UP! You are now Level ${state.level}!`);
        hero.hp = getHeroMaxHp();
      }
    }

export function updateXPUI() {
      if(document.getElementById('level-val')) {
        document.getElementById('level-val').innerText = state.level;
        document.getElementById('xp-val').innerText = state.xp;
        document.getElementById('xp-next').innerText = state.xpToNext;
        document.getElementById('xp-fill').style.width = Math.min(100, (state.xp / state.xpToNext) * 100) + '%';
      }
    }

export function switchTab(tabId) {
      playSFX('tab_switch');
      document.querySelectorAll('.tab-btn').forEach(btn => btn.classList.remove('active'));
      document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));
      
      const targetBtn = Array.from(document.querySelectorAll('.tab-btn')).find(b => b.getAttribute('onclick') && b.getAttribute('onclick').includes(tabId));
      if (targetBtn) targetBtn.classList.add('active');
      
      const targetContent = document.getElementById('tab-' + tabId);
      if (targetContent) targetContent.classList.add('active');

      // If switching to arena or alliances, initialize specialized systems
      if (tabId === 'arena') {
        if (window.CombatEngine) {
          CombatEngine.init();
        }
        log(`[ARENA]: Staging 5-Hero RPG lane battle & Lanchester mass attrition engine.`);
      } else if (tabId === 'alliances') {
        if (window.AlliancesEngine) {
          AlliancesEngine.init();
        }
        log(`[ALLIANCES]: Loaded Syndicate Alliances & City Hall Megalopolis race.`);
      } else if (tabId === 'compound') {
        updateCompoundUI();
      } else if (tabId === 'world') {
        setTimeout(() => {
          if (window.init3DWarTable && (!window.warTable || !window.warTable.initialized)) {
            window.init3DWarTable();
          }
          if (window.resize3DWarTable) window.resize3DWarTable();
        }, 60);
      }
    }

export function handleStartGate() {
      enterGame();
    }

export function enterGame() {
      playSFX('tab_switch');
      startBGM();
      document.getElementById('start-screen').classList.add('hidden');
      const track = bgmPlaylist[currentBGMIndex];
      log(`♫ Syndicate Radio: "${track.title}" by ${track.artist} active.`);
      updateHUDDirective();
      updateCompoundUI();
      if (typeof renderCharacterDossier === 'function') {
        renderCharacterDossier(selectedDossierId || 'boss');
      }

      const handle = localStorage.getItem("mesquite_player_handle");
      const tutorialDone = localStorage.getItem("mesquite_tutorial_completed");
      const isUnset = !handle || handle === "UNREGISTERED BOSS" || handle === "[ ROOKIE BOSS ]" || handle.toLowerCase().includes("micah");

      if (isUnset || !tutorialDone) {
        if (typeof openTutorialModal === 'function') {
          openTutorialModal(1);
        }
      }
    }

export function switchStartScreenVideo(src, btnElement) {
      playSFX('click');
      const video = document.getElementById('start-screen-video');
      if (video) {
        video.src = src;
        video.play().catch(() => {});
      }
      if (btnElement) {
        document.querySelectorAll('.scene-pill-btn').forEach(b => b.classList.remove('active'));
        btnElement.classList.add('active');
      }
    }

export function getActiveDirective() {
      if (!state.missions) return null;
      for (let chKey in state.missions) {
        const ch = state.missions[chKey];
        if (ch && ch.tasks) {
          for (let tKey in ch.tasks) {
            const t = ch.tasks[tKey];
            if (!t.done) {
              return { chapterKey: chKey, chapterName: ch.name, taskKey: tKey, task: t };
            }
          }
        }
      }
      return null;
    }

export function updateHUDDirective() {
      const bar = document.getElementById('hud-directive-bar');
      if (!bar) return;
      const active = getActiveDirective();
      if (!active) {
        const tagEl = document.getElementById('directive-chapter-tag');
        if (tagEl) tagEl.innerText = "SYNDICATE SUPREMACY";
        const titleEl = document.getElementById('directive-title-text');
        if (titleEl) titleEl.innerText = "All Directives Completed";
        const descEl = document.getElementById('directive-desc-text');
        if (descEl) descEl.innerText = "Mesquite Underworld is under your complete syndicate dominion.";
        const barEl = document.getElementById('directive-progress-bar');
        if (barEl) barEl.style.width = "100%";
        const cntEl = document.getElementById('directive-counter-text');
        if (cntEl) cntEl.innerText = "DOMINION";
        const rewEl = document.getElementById('directive-reward-val');
        if (rewEl) rewEl.innerText = "KINGPIN STATUS";
        const cBtn = document.getElementById('directive-claim-btn');
        if (cBtn) cBtn.style.display = 'none';
        const aBtn = document.getElementById('directive-action-btn');
        if (aBtn) aBtn.style.display = 'none';
        return;
      }

      const { chapterKey, chapterName, taskKey, task } = active;
      currentActiveDirective = { chapterKey, taskKey, task };

      const tagEl = document.getElementById('directive-chapter-tag');
      if (tagEl) tagEl.innerText = chapterName.toUpperCase();
      const titleEl = document.getElementById('directive-title-text');
      if (titleEl) titleEl.innerText = task.title;
      const descEl = document.getElementById('directive-desc-text');
      if (descEl) descEl.innerText = task.desc;

      const pct = Math.min(100, Math.floor(((task.progress || 0) / task.req) * 100));
      const barEl = document.getElementById('directive-progress-bar');
      if (barEl) barEl.style.width = pct + '%';
      const cntEl = document.getElementById('directive-counter-text');
      if (cntEl) cntEl.innerText = `${task.progress || 0} / ${task.req}`;

      let rewParts = [];
      if (task.reward.cash) rewParts.push(`+$${task.reward.cash.toLocaleString()} Cash`);
      if (task.reward.cleanCapital) rewParts.push(`+$${task.reward.cleanCapital.toLocaleString()} Clean`);
      if (task.reward.scrap) rewParts.push(`+⚙️ ${task.reward.scrap} Scrap`);
      if (task.reward.cred) rewParts.push(`+💎 ${task.reward.cred} Cred`);
      if (task.reward.product) rewParts.push(`+📦 ${task.reward.product} Distro`);
      if (task.reward.xp) rewParts.push(`+${task.reward.xp} XP`);
      if (task.reward.unlockSector) rewParts.push(`🔓 Sector ${task.reward.unlockSector.toUpperCase()}`);
      const rewEl = document.getElementById('directive-reward-val');
      if (rewEl) rewEl.innerText = rewParts.join(' • ');

      const claimBtn = document.getElementById('directive-claim-btn');
      const actionBtn = document.getElementById('directive-action-btn');

      if ((task.progress || 0) >= task.req && !task.done) {
        if (claimBtn) claimBtn.style.display = 'inline-block';
        if (actionBtn) actionBtn.style.display = 'none';
      } else {
        if (claimBtn) claimBtn.style.display = 'none';
        if (actionBtn) {
          actionBtn.style.display = 'inline-block';
          actionBtn.innerText = `⚡ GO TO MISSION`;
        }
      }
    }

export function claimActiveHUDDirective() {
      if (currentActiveDirective) {
        claimMission(currentActiveDirective.chapterKey, currentActiveDirective.taskKey);
      }
    }

export function executeDirectiveAction() {
      if (!currentActiveDirective || !currentActiveDirective.task) return;
      const t = currentActiveDirective.task;
      playSFX('click');
      if (t.targetTab) switchTab(t.targetTab);
      if (t.targetAction === 'march_s1_scrap') {
        selectSector('s1_scrap');
      } else if (t.targetAction === 'march_s2') {
        selectSector('s2');
      } else if (t.targetAction === 'march_s3') {
        selectSector('s3');
      } else if (t.targetAction === 'boss_mike') {
        selectBoss('mike');
      } else if (t.targetAction === 'boss_hector') {
        selectBoss('hector');
      } else if (t.targetAction === 'boss_beau') {
        selectBoss('beau');
      } else if (t.targetAction === 'boss_vance') {
        selectBoss('vance');
      } else if (t.targetAction === 'upgrade_compound') {
        const el = document.getElementById('btn-upgrade-compound');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }

